import { ButtonsOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { IPageComponentOverlappedComponentData } from './overlapped-component.interface';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../../config/component.config';

const isLargerVideoVariant = (data: IPageComponentOverlappedComponentData) => data.is_larger_video;
const isSmallerVideoVariant = (data: IPageComponentOverlappedComponentData) => data.is_smaller_video;

export const config: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'> = {
    id: 'overlapped-component',
    name: 'Overlapped component',
    image: 'assets/images/cms/overlapped.png',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'larger_element',
            title: 'Larger Image Element'
        },
        <NICmsContentField.IField>{
            key: 'larger_image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image'
        },
        <NICmsContentField.IField>{
            key: 'larger_image_link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        },
        <NICmsContentField.IField>{
            key: 'is_larger_video',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Switch to change image to video',
            default: false,
            required: true
        },
        <NICmsContentField.IField>{
            key: 'larger_video_url',
            type: NICmsContentField.EFieldType.text,
            title: 'Video URL or ID',
            description: 'Provide the video ID (eq. 1234567)',
            canShow: isLargerVideoVariant
        },
        <NICmsContentField.IField>{
            key: 'larger_video_autoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Video Autoplay',
            canShow: isLargerVideoVariant
        },
        <NICmsContentField.IField>{
            key: 'larger_video_background_mode',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Background Mode',
            canShow: isLargerVideoVariant
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'smaller_element',
            title: 'Smaller Image Element'
        },
        <NICmsContentField.IField>{
            key: 'smaller_image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image'
        },
        <NICmsContentField.IField>{
            key: 'smaller_image_link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        },
        <NICmsContentField.IField>{
            key: 'is_smaller_video',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Switch to change image to video',
            default: false,
            required: true
        },
        <NICmsContentField.IField>{
            key: 'smaller_video_url',
            type: NICmsContentField.EFieldType.text,
            title: 'Video URL or ID',
            description: 'Provide the video ID (eq. 1234567)',
            canShow: isSmallerVideoVariant
        },
        <NICmsContentField.IField>{
            key: 'smaller_video_autoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Video Autoplay',
            canShow: isSmallerVideoVariant
        },
        <NICmsContentField.IField>{
            key: 'smaller_video_background_mode',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Background Mode',
            canShow: isSmallerVideoVariant
        },
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Title'
        },
        <NICmsContentField.IField>{
            key: 'paragraph',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Paragraph'
        },
        <NICmsContentField.IField>{
            key: 'cta_text',
            type: NICmsContentField.EFieldType.text,
            title: 'Button Text'
        },
        <NICmsContentField.IField>{
            key: 'cta_url',
            type: NICmsContentField.EFieldType.text,
            title: 'Button Link'
        },
        <NICmsContentField.IChoiceField>{
            key: 'cta_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Button Style',
            options: ButtonsOptions,
            default: 'button-inline'
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};

export default config;
